import React from 'react'

const medalImages = {
  gold: '/assets/img/achievements/gold.png',
  silver: '/assets/img/achievements/silver.png',
  bronze: '/assets/img/achievements/bronze.png',
}

const Achievement = ({ event, achievement = 'bronze' }) => {
  const medal = achievement.toLowerCase()
  const medalSrc = medalImages[medal] || medalImages.bronze

  return (
    <div className="achievement-card">
      <div className={`achievement-medal-wrapper ${medal}`}>
        <img
          src={medalSrc}
          alt={`${medal} medal`}
          className="achievement-medal"
        />
      </div>

      <h4 className="achievement-title">{event}</h4>
      <span className={`achievement-badge ${medal}`}>
        {medal.toUpperCase()}
      </span>
    </div>
  )
}

export default Achievement
